module.exports = __webpack_public_path__ + "static/media/archer_destination_hover.2f3ffa99.svg";